import React, { FC} from 'react'
import { Grid } from '@mui/material'
import Button from '../../../components/button/Button'
import { FormattedMessage } from 'react-intl'
import { getKeyFromRaisonRefusValue } from '../enums/raisonRefusEnum'
import Loader from '../../../components/loader/Loader'
import { makeStyles } from 'tss-react/mui'
import { LoadingState } from '../types/loadingState'

interface RaisonRefusBtnProps {
	raisonRefus: number
	loadingState: LoadingState
	onClickRefus: (raisonRefus: number) => void
}

const RaisonRefusBtn: FC<RaisonRefusBtnProps> = (
	{
		raisonRefus,
		loadingState,
		onClickRefus
	}) => {
	const { classes } = useStyles()

	return (
		<Grid item key={`raison_refus_rdv_${raisonRefus}`}>
			<Button
				background="backgroundWhite"
				color="colorAccessibility"
				textStyle="text4"
				buttonStyle={classes.buttonStyle}
				onClick={() => onClickRefus(raisonRefus)}
				disabled={loadingState.loading}
				fullWidth
			>
				<FormattedMessage
					id={`visites.popin.refusRDV.raisons.${getKeyFromRaisonRefusValue(raisonRefus).toLowerCase()}`}
					defaultMessage="Raison de refus"
					description="Raison de refus"
				/>
				{loadingState.loading && loadingState.index === raisonRefus && <Loader size={17} />}
			</Button>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	buttonStyle: {
		border: `1px solid ${theme.palette.accessibility.main}`,
		borderRadius: 25,
		'& div': {
			marginLeft: 5,
			display: 'flex'
		}
	}
}))

export default RaisonRefusBtn